module.exports = __webpack_public_path__ + "static/img/xiao.297d5137.png";